import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DATA_ACCESS_TOGGLES_FEATURE_KEY } from './data-access-toggles.reducer';

import { FeatureFlagToggleList, FeatureFlagToggles } from '../../interface/feature-flags.interfaces';

export const getDataAccessTogglesState = createFeatureSelector<FeatureFlagToggleList>(DATA_ACCESS_TOGGLES_FEATURE_KEY);

export const getToggles = createSelector(getDataAccessTogglesState, (state: FeatureFlagToggleList) => state);

export const getToggle = createSelector(
  getDataAccessTogglesState,
  (state: FeatureFlagToggleList, props: { key: FeatureFlagToggles }) => (props.key in state ? state[props.key] : false)
);
